import { FC, useState } from "react";
import { Stack, useTheme } from "@mui/material";
import {
  FormikCheckbox,
  FormikSelectField,
  FormikSelectSearchField,
  TableToggleField
} from "@vilocnv/allsetra-core";
import DateAndTimeFilters from "../../DateAndTimeFilters/DateAndTimeFilters";
import DaysFilters from "../../DaysFilter/DaysFilter";
import TimeFilters from "../../TimeFilters/TimeFilters";
import { FormLabelText, LabelRowBox } from "./InnerForm.styled";

interface Props {
  groups: Array<any>;
  objectTypes: Array<any>;
  objects: Array<any>;
  dataLoading?: boolean;
  translator: any;
  fetchOnDebounce: (value: string) => void;
  onChange?: () => void;
  isReportsHistoryPage?: boolean;
  values: any;
}

const InnerForm: FC<Props> = ({
  groups,
  objectTypes,
  objects,
  dataLoading = false,
  translator,
  fetchOnDebounce,
  onChange,
  isReportsHistoryPage = false,
  values
}) => {
  const theme = useTheme();
  const [isSelectDaysAndTimeEnable, setIsSelectDaysAndTimeEnable] =
    useState(false);

  const handleToggleDaysAndTimeChange = (value: boolean) => {
    setIsSelectDaysAndTimeEnable(value);
  };

  const commonFieldProps = {
    fullWidth: true
  };
  return (
    <Stack spacing={2}>
      {/* <FormikSelectField
        {...commonFieldProps}
        theme={theme}
        multiple
        searchable
        label={translator("objectType.label", { ns: "formFieldsTranslation" })}
        placeholder={translator("objectType.placeholder", {
          ns: "formFieldsTranslation"
        })}
        name="objectType"
        options={objectTypes ?? []}
        optionLabelKey="name"
        optionValueKey="uniqueId"
        loading={dataLoading}
      /> */}

      <FormikCheckbox
        theme={theme}
        name="assignedToAllObjects"
        label={translator("selectAllObjects.label", {
          ns: "formFieldsTranslation"
        })}
      />

      {!values.assignedToAllObjects && (
        <>
          <LabelRowBox>
            <FormLabelText>
              {translator("objects.label", { ns: "formFieldsTranslation" })}
            </FormLabelText>
          </LabelRowBox>
          <FormikSelectSearchField
            fetchOnDebounce={fetchOnDebounce}
            // label={translator("objects.label", { ns: "formFieldsTranslation" })}
            placeholder={translator("objects.placeholder", {
              ns: "formFieldsTranslation"
            })}
            name="object"
            options={objects ?? []}
            optionLabelKey="name"
            optionValueKey="uniqueId"
            loading={dataLoading}
            multiple
            searchable
            {...commonFieldProps}
            onChange={onChange}
            sx={{
              marginTop: "0 !important",
              "& .MuiAutocomplete-hasClearIcon.css-1x6bjyf-MuiAutocomplete-root .MuiOutlinedInput-root":
                {
                  paddingRight: "9px"
                }
            }}
            //@ts-ignore
            showStates
            showDropdownIcon
          />
        </>
      )}

      {groups?.length ? (
        <FormikSelectField
          theme={theme}
          label={translator("groups.label", { ns: "formFieldsTranslation" })}
          placeholder={translator("groups.placeholder", {
            ns: "formFieldsTranslation"
          })}
          multiple
          searchable
          name="group"
          options={groups ?? []}
          optionLabelKey="name"
          optionValueKey="uniqueId"
          loading={dataLoading}
          {...commonFieldProps}
        />
      ) : (
        <></>
      )}

      {/* {!isReportsHistoryPage && <DateAndTimeFilters values={values} />} */}
    </Stack>
  );
};

export default InnerForm;
